import React from 'react';
import { 
  Briefcase, ShieldAlert, Landmark, Scale, Users 
} from 'lucide-react';
import { useDashboard } from '../../contexts/DashboardContext';

const tabs = [
  { key: 'portfolio', label: 'Portfolio Overview', icon: Briefcase },
  { key: 'risk', label: 'Risk & Asset Quality', icon: ShieldAlert },
  { key: 'deposits', label: 'Deposits & Liquidity', icon: Landmark },
  { key: 'psl', label: 'PSL & Regulatory', icon: Scale },
  { key: 'customers', label: 'Customer Insights', icon: Users },
];

const DashboardTabs = () => {
  const { activeTab, setActiveTab } = useDashboard();

  return (
    <div className="bg-white rounded-xl border border-slate-200 mb-6">
      <div className="flex overflow-x-auto scrollbar-hide">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.key;
          
          return (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              data-testid={`tab-${tab.key}`}
              className={`
                flex items-center gap-2 px-5 py-3.5 text-sm font-medium whitespace-nowrap
                transition-all duration-200 border-b-2 flex-1 justify-center
                ${isActive 
                  ? 'text-emerald-600 border-emerald-500 bg-emerald-50/50' 
                  : 'text-slate-500 border-transparent hover:text-slate-700 hover:bg-slate-50'
                }
              `}
            >
              <Icon className={`w-4 h-4 ${isActive ? 'text-emerald-500' : 'text-slate-400'}`} />
              <span className="hidden sm:inline">{tab.label}</span>
              <span className="sm:hidden">{tab.label.split(' ')[0]}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default DashboardTabs;
